import {
  ArrowUpDown,
  Bus,
  Calendar,
  CircleAlert,
  Info,
  ChevronLeft,
  DoorOpen,
  Download,
  Eye,
  FileText,
  FileUser,
  Fingerprint,
  History,
  Home,
  LayoutDashboard,
  LogOut,
  Mail,
  MapPin,
  Menu,
  Search,
  Settings,
  ShieldAlert,
  Trash2,
  User,
  UserPlus,
  Users,
  X,
  MessageSquareText
} from 'lucide-angular';

export const Icons = {
  ArrowUpDown,
  Bus,
  Calendar,
  CircleAlert,
  Info,
  ChevronLeft,
  DoorOpen,
  Download,
  Eye,
  FileText,
  FileUser,
  Fingerprint,
  Home,
  LayoutDashboard,
  LogOut,
  Menu,
  Settings,
  ShieldAlert,
  History,
  Trash2,
  User,
  UserPlus,
  Users,
  Mail,
  MapPin,
  Search,
  X,
  MessageSquareText
} as const;